import React, { 
  Component
} from 'react';

import {
  Theme,
  Drawer,
  Text,
  Link,
  Grid,
  Button 
} from '@resultadosdigitais/tangram-components';

import EventTrackerAPI from 'src/event-tracker/api';
import EventEmitter from 'src/services/event_emitter';
import I18n from 'src/locales/i18n';

export default class IntegratorsDrawer extends Component {
  constructor() {
    super()
    this.state = { open: false };
  }

  componentDidMount() {
    EventEmitter.on('INTEGRATOR_TAG_CLICK', () => this.setState({ open: true }))
  }

  componentWillUnmount() {
    EventEmitter.off('INTEGRATOR_TAG_CLICK');
  }

  render() {
    return (
      <Theme value={ Theme.kinds.lina }>
        <Drawer
          open={ this.state.open }
          onClose={ () => this.setState({ open: false }) }
          anchor={ Drawer.anchors.right }
          scrim={ true }>
          <Drawer.Header onDismiss={ () => this.setState({ open: false }) }>
            <Drawer.Title>{ I18n.t('integrators_drawer.title') }</Drawer.Title>
          </Drawer.Header>

          <Drawer.Body>
            <Text token={ Text.tokens.TEXT_MD_BOLD }>{ I18n.t('integrators_drawer.subtitle') }</Text>
            <Text>{ I18n.t('integrators_drawer.text.text_p1_html') }</Text>
            <Text>{ I18n.t('integrators_drawer.text.text_p2_html') }</Text>
            <Text>{ I18n.t('integrators_drawer.text.text_p3_html') }</Text>
            <Text>{ I18n.t('integrators_drawer.text.text_p4_html') }</Text>
            <Text>{ I18n.t('integrators_drawer.text.text_p5_html') }</Text>

            { this.renderHelpCenterLinks() }
          </Drawer.Body>

          <Drawer.Actions>
            <Grid.Row align='flex-start'>
              <Button
                kind={ Button.kinds.secondary }
                onClick={ () => this.setState({ open: false }) }>
                { I18n.t('integrators_drawer.understood') }
              </Button> 
            </Grid.Row>
          </Drawer.Actions>
        </Drawer>
      </Theme>
    );
  }

  renderHelpCenterLinks() {
    const integrators = ['Zapier', 'Pluga', 'Integromat'];

    return integrators.map((integratorName) => {
      const integratorKey = integratorName.toLowerCase();
      const integratorUrl = I18n.t(`integrators_drawer.${integratorKey}_url`)

      return (
        <Text key={ integratorKey }>
          <Link
            href={ integratorUrl }
            onClick={ () => this.handleHelpCenterClick(integratorName, integratorUrl) }
            target="_BLANK">
            { I18n.t(`integrators_drawer.integrating_with_${integratorKey}`) }
          </Link>
        </Text>
      );
    })
  }

  handleHelpCenterClick(integratorName, integratorUrl) {
    EventTrackerAPI.postAnonymousTrackingEvent({
      event_name: 'Visitor clicked on a integrator help center link',
      integrator_name: integratorName,
      help_center_url: integratorUrl,
      language: I18n.language
    });
  }
}
